import { useState, useEffect } from "react"
import { useUpdateTaskBaseMutation, useDeleteTaskBaseMutation } from "./taskBasesApiSlice"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import ActionsListAddEdit from '../actions/ActionsListAddEdit'
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
import GradeStepsMain from "../grade-steps/GradeStepsMain"


const EditTaskBaseForm = ({ taskBase, courses }) => {

    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateTaskBase, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateTaskBaseMutation()

    const [deleteTaskBase, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteTaskBaseMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(taskBase.title)
    const [body, setBody] = useState(taskBase.body)
    const [course, setCourse] = useState(taskBase.course?._id)
    const [active, setActive] = useState(taskBase.active)
    const [incluedInGrade, setIncluedInGrade] = useState(taskBase.incluedInGrade)
    const [defaultCheckInclueRelatedFriends, setDefaultCheckInclueRelatedFriends] = useState(taskBase.defaultCheckInclueRelatedFriends)
    const [order, setOrder] = useState(taskBase.order)
    const [ratio, setRatio] = useState(taskBase.ratio)
    const [img, setImg] = useState(taskBase.img)
    const [gradeSteps, setGradeSteps] = useState(taskBase.gradeSteps || [])



    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setTitle('')
            setBody('')
            setCourse('')
            setActive(true)
            setOrder(0)
            setRatio(0)
            navigate(`/${type}/${groupId}/task-bases`)
        }

    }, [isSuccess, isDelSuccess, navigate])

  
    const canSave = [title, body, course].every(Boolean) && !isLoading

    const onSaveTaskBaseClicked = async (e) => {
        if (canSave) {
             const savedGradesSteps = gradeSteps.map(step => {
                return {
                    ...step,
                    _id: step._id.length > 20? step._id : undefined
                }
            })  
            await updateTaskBase({ id: taskBase._id, course, title, body, active,  img, ratio, order, incluedInGrade ,defaultCheckInclueRelatedFriends , gradeSteps: savedGradesSteps })
        }
    }

    const onDeleteTaskBaseClicked = async () => {
        await deleteTaskBase({ id: taskBase._id })
    }

    const created = new Date(taskBase.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(taskBase.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    const options = courses.map(course => {
        return (
            <option
                key={course.id}
                value={course.id}
            > {course.name}</option >
        )
    })


    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isTeacher || isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteTaskBaseClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit TaskBase</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to TaskBase"
                            onClick={()=>{navigate(`/${type}/${groupId}/task-bases`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                     
                       
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveTaskBaseClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                    </div>
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="body">
                    Body:</label>
                    <ReactQuill
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                         // [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          [{size: []}],
                          [{ color: [] }, { background: [] }],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                </div>
                <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

              
                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="course">
                    COURSE:</label>
                <select
                    id="course"
                    name="course"
                    className={`form__input  ${!course &&'form__input--incomplete'}`}
                    value={course}
                    onChange={(e)=>setCourse(e.target.value)}
                >
                    {options}
                </select>
                    </div>
                    <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>
                   
                    
                      

                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-relatedFriend">
                  סימון ציון גם לחברות בברירת מחדל
                    <input
                        className="form__checkbox"
                        id="user-relatedFriend"
                        name="user-relatedFriend"
                        type="checkbox"
                        checked={defaultCheckInclueRelatedFriends}
                        onChange={(e)=>setDefaultCheckInclueRelatedFriends(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>

 <div className="form-input-container">
                    <GradeStepsMain gradeSteps={gradeSteps} setGradeSteps={setGradeSteps} />
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
               
            </form>
           
            <div className="form__divider">
                        <p className="form__created">Created:<br />{created}</p>
                        <p className="form__updated">Updated:<br />{updated}</p>
            </div>
            <Outlet />
        </>
    )

    return content
}

export default EditTaskBaseForm